import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CampaignBuilder = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    platform: 'facebook',
    content: '',
    targetAudience: '',
    budget: '',
    startDate: '',
    endDate: '',
    status: 'draft'
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setSaving(true);
    try {
      await onSave(formData);
    } catch (error) {
      console.error('Error saving campaign:', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-background rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-background border-b border-border p-6 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground flex items-center">
            <Icon name="Plus" size={24} className="mr-2 text-primary" />
            Nueva Campaña de Marketing
          </h2>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Nombre de la Campaña
            </label>
            <Input
              value={formData?.name}
              onChange={(e) => setFormData({ ...formData, name: e?.target?.value })}
              placeholder="Ej: Lanzamiento Residencial 3 Volcanes"
              required
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Plataforma
            </label>
            <Select
              value={formData?.platform}
              onChange={(e) => setFormData({ ...formData, platform: e?.target?.value })}
              required
            >
              <option value="facebook">Facebook</option>
              <option value="instagram">Instagram</option>
              <option value="whatsapp">WhatsApp Business</option>
              <option value="linkedin">LinkedIn</option>
            </Select>
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Contenido del Mensaje
            </label>
            <textarea
              value={formData?.content}
              onChange={(e) => setFormData({ ...formData, content: e?.target?.value })}
              placeholder="Escribe el contenido de tu campaña..."
              rows={4}
              className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-background text-foreground"
              required
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Audiencia Objetivo
            </label>
            <Input
              value={formData?.targetAudience}
              onChange={(e) => setFormData({ ...formData, targetAudience: e?.target?.value })}
              placeholder="Ej: Profesionales 30-45 años, Arequipa"
              required
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">
                Presupuesto (USD)
              </label>
              <Input
                type="number"
                value={formData?.budget}
                onChange={(e) => setFormData({ ...formData, budget: e?.target?.value })}
                placeholder="1000"
                required
              />
            </div>
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">
                Estado
              </label>
              <Select
                value={formData?.status}
                onChange={(e) => setFormData({ ...formData, status: e?.target?.value })}
              >
                <option value="draft">Borrador</option>
                <option value="active">Activa</option>
                <option value="paused">Pausada</option>
              </Select>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">
                Fecha de Inicio
              </label>
              <Input
                type="date"
                value={formData?.startDate}
                onChange={(e) => setFormData({ ...formData, startDate: e?.target?.value })}
                required
              />
            </div>
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">
                Fecha de Fin
              </label>
              <Input
                type="date"
                value={formData?.endDate}
                onChange={(e) => setFormData({ ...formData, endDate: e?.target?.value })}
                required
              />
            </div>
          </div>

          <div className="flex items-center space-x-3 pt-4">
            <Button
              type="submit"
              fullWidth
              iconName="Save"
              disabled={saving}
            >
              {saving ? 'Guardando...' : 'Crear Campaña'}
            </Button>
            <Button
              type="button"
              variant="outline"
              fullWidth
              onClick={onClose}
              disabled={saving}
            >
              Cancelar
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CampaignBuilder;
